<p>water-detail-template works!</p>
